import { createSlice } from '@reduxjs/toolkit';
import type { AsyncStatus } from '@/shared/types/asyncState';
import type { DashboardLexiData } from '../../types/dashboardLexi';
import { fetchDashboardLexi } from './actions';

interface DashboardLexiState {
  data: DashboardLexiData | null;
  loading: boolean;
  error: string | null;
  status: AsyncStatus;
  currentRequestId: string | null;
}

const initialState: DashboardLexiState = {
  data: null,
  loading: false,
  error: null,
  status: 'idle',
  currentRequestId: null,
};

const dashboardLexiSlice = createSlice({
  name: 'dashboardLexi',
  initialState,
  reducers: {
    clearDashboardLexiError: (state) => {
      state.error = null;
      state.status = 'idle';
    },
    resetDashboardLexi: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDashboardLexi.pending, (state, action) => {
        state.loading = true;
        state.error = null;
        state.status = 'loading';
        state.currentRequestId = action.meta.requestId;
      })
      .addCase(fetchDashboardLexi.fulfilled, (state, action) => {
        if (action.meta.requestId !== state.currentRequestId) return;
        state.loading = false;
        state.data = action.payload;
        state.status = 'success';
        state.currentRequestId = null;
      })
      .addCase(fetchDashboardLexi.rejected, (state, action) => {
        if (action.meta.requestId !== state.currentRequestId) return;
        state.loading = false;
        state.error = action.payload ?? 'Erro desconhecido';
        state.status = 'error';
        state.currentRequestId = null;
      });
  },
});

export const { clearDashboardLexiError, resetDashboardLexi } = dashboardLexiSlice.actions;
export const dashboardLexiReducer = dashboardLexiSlice.reducer;
